/**
 * @param {number} lockSeconds
 * @returns {string} 空字串代表不顯示
 */
export function offlineNoticeText(lockSeconds) {
    if (!(lockSeconds > 0)) {
        return '';
    }

    const minutes = Math.round(lockSeconds / 60);

    return `此付款方式需另外完成付款，號碼將保留 ${minutes} 分鐘；逾時號碼將自動釋放，已付款項將轉為儲值點數。`;
}
